import React from 'react';

import { useNavigationState } from '@store/hookstate';
import { useHistory, useLocation } from 'react-router-dom';

import PeopleManagementImg from '@assets/svg/blue-people.svg';
import PeopleGrayImg from '@assets/svg/new-people.svg';
import DataManagementImg from '@assets/svg/database.svg';
import DataBlueManagementImg from '@assets/svg/database-blue.svg';
import TagManagementImg from '@assets/svg/tag.svg';
import TagBlueManagementImg from '@assets/svg/tag-blue.svg';
// import CustomizeImg from '@assets/svg/style.svg';
// import ContactsImg from '@assets/svg/id-number.svg';

import { Topic } from './Components/Topic/Topic';
import { StudioData } from './Components/StudioData/StudioData';
import { UserManagement } from './Components/UserManagement/UserManagement';

import {
  Body,
  Container,
  Left,
  LeftBody,
  LeftHead,
  Right,
  Title,
  Divider,
  StudioDataDiv,
  TopicsDiv,
} from './ConfigurationPage.styles';
import { FieldManagement } from './Components/FieldsManagement/FieldManagement';
import { TagsManagement } from './Components/TagsManagement/TagsManagement';

const useInfiniteQueryParams = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const ConfigurationPage = () => {
  const navigationState = useNavigationState();

  const query = useInfiniteQueryParams();
  const history = useHistory();
  const page = query.get('tab');

  if (!page) {
    history.push('/configuration?tab=user');
  }

  const UserActive = () => {
    if (page === 'user') return true;
    return false;
  };

  const UserActiveIcon = () => {
    if (page === 'user') return PeopleManagementImg;
    return PeopleGrayImg;
  };

  const FieldActive = () => {
    if (page === 'field-management') return true;
    return false;
  };

  const FieldActiveIcon = () => {
    if (page === 'field-management') return DataBlueManagementImg;
    return DataManagementImg;
  };

  const TagsActive = () => {
    if (page === 'tags') return true;
    return false;
  };

  const TagsActiveIcon = () => {
    if (page === 'tags') return TagBlueManagementImg;
    return TagManagementImg;
  };

  return (
    <Container>
      <Body offsetTop={navigationState.offsetTop.get()}>
        <Left>
          <LeftBody>
            <LeftHead>
              <Title>Configuration</Title>
            </LeftHead>
            <Divider height="24px" />

            <TopicsDiv>
              <Topic
                Icon={<img src={UserActiveIcon()} alt="icon" />}
                title="User Management"
                description="Edit roles, invite and remove members"
                active={UserActive()}
                onClick={() => {
                  history.push('/configuration?tab=user');
                }}
              />
              <Topic
                Icon={<img src={FieldActiveIcon()} alt="icon" />}
                title="Fields Management"
                description="Manage custom fields and status"
                active={FieldActive()}
                onClick={() => {
                  history.push('/configuration?tab=field-management');
                }}
              />
              <Topic
                Icon={<img src={TagsActiveIcon()} alt="icon" />}
                title="Tag Management"
                description="Manage tags and categories, including mass actions"
                active={TagsActive()}
                onClick={() => {
                  history.push('/configuration?tab=tags');
                }}
              />
              {/* <Topic
                Icon={<img src={CustomizeImg} alt="icon" />}
                title="Customizations"
                description="Define how your data will be displayed"
                comingSoon
              />
              <Topic
                Icon={<img src={ContactsImg} alt="icon" />}
                title="Contacts"
                description="Add and assign contacts to products"
                comingSoon
              /> */}
            </TopicsDiv>
            <StudioDataDiv>
              <StudioData />
            </StudioDataDiv>
          </LeftBody>
        </Left>
        <Right>
          {page === 'user' && <UserManagement />}
          {page === 'field-management' && <FieldManagement />}
          {page === 'tags' && <TagsManagement />}
        </Right>
      </Body>
    </Container>
  );
};

export { ConfigurationPage };
